<template>
  <div class="breadcrumbs">
    <div class="route">
      <div v-for="(leg, index) in hotels.route" :key="index">
        <span v-if="isCurrent(index)" class="on">
          {{ label(leg) }}
        </span>
        <span v-else-if="isLink(leg, index)">
          <a @click="visit(index)">{{ label(leg) }}</a>
        </span>
        <span v-else>{{ label(leg) }}</span>
        <span v-if="isArrow(index)" class="arrow">&nbsp;&#8250;&nbsp;</span>
      </div>
      <span class="arrow">|</span>
      <div><a @click="edit">Edit Search</a></div>
    </div>
  </div>
</template>

<script setup>
import DateTime from "../utils/datetime";

// Props and emits
const props = defineProps(["hotels", "legIndex"]);
const emit = defineEmits(["update:isSavedRoute", "update:legIndex"]);

const { utilDateFlightfox } = DateTime();

// Methods
const edit = () => {
  emit("update:isSavedRoute", false);
};

const isArrow = index => {
  return index < props.hotels.route.length - 1;
};

const isCurrent = index => {
  return props.legIndex === index;
};

const isLink = (leg, index) => {
  if (index < props.legIndex) {
    return true;
  }
  if (leg.ideal.length > 0) {
    return true;
  }
  return false;
};

const label = leg => {
  return utilDateFlightfox(leg.checkin) + " · " + leg.place.name;
};

const visit = index => {
  emit("update:legIndex", index);
};
</script>

<style lang="less">
#hotels {
  .breadcrumbs {
    align-items: flex-end;
    border-bottom: 0.0625rem solid @border;
    display: flex;
    margin-bottom: 2rem;
    padding-bottom: 0.5rem;

    .route {
      color: @mid;

      div {
        margin-bottom: 0.5rem;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .on {
        color: @dark;
        display: inline-block;
      }
    }

    .arrow {
      display: none;
    }
  }
}

@media screen and (min-width: 60em) {
  #hotels {
    .breadcrumbs {
      .route {
        display: flex;

        div {
          margin-bottom: 0;
        }
      }

      .arrow {
        display: inline;
        padding: 0 0.5rem;
      }
    }
  }
}
</style>
